// HomeFilterBar — therapy-specific status/month filters removed for Vidnight
export function HomeFilterBar() {
  return null;
}
